const STORAGE_KEY = "komptai_last_activity";
const WRITE_THROTTLE_MS = 5000;

let lastWrite = 0;
let inFlight = 0;

export const markActivity = (force = false) => {
  const now = Date.now();
  if (!force && now - lastWrite < WRITE_THROTTLE_MS) return;
  lastWrite = now;
  try {
    localStorage.setItem(STORAGE_KEY, String(now));
  } catch (e) {
    // storage unavailable (private mode) — timer falls back to in-memory
  }
};

export const getLastActivity = () => {
  try {
    const v = Number(localStorage.getItem(STORAGE_KEY));
    if (Number.isFinite(v) && v > 0) return v;
  } catch (e) { /* ignore */ }
  return lastWrite || Date.now();
};

export const incrementInFlight = () => { inFlight += 1; };
export const decrementInFlight = () => { inFlight = Math.max(0, inFlight - 1); };
export const getInFlightCount = () => inFlight;
